import moment from 'moment'

var field = {
  width: '100px',
  display: 'inline-block',
  paddingRight: '6px',
  textAlign: 'left'
}

var DEFAULT_FORM_VALUES = {
  uploadOrEnter: 'Enter'
}

export const data = () => ({
  composedText: '',
  formComplete: false,
  formData: {
    ...DEFAULT_FORM_VALUES
  },
  uploadOrEnter: '',
  uploadOrEnterList: [],
  loading: false,
  file: null,
  isDebug: true,
  toggle: false,
  completeToggle: false,
  openOnFocus: true,
  isReadOnly: false,
  buttonText: 'Add',
  base64pdf: '',
  pageCount: [],
  scale: 1,
  imageContent: null,
  documentName: '',
  attachment: false,
  communicationDocumentID: 0,
  communicationID: 0,
  documentFile: null,
  selectedMailMessage: false,

  formatDateFn: function(value) {
    return value && value != undefined
      ? moment(value.toString(), 'YYYY/MM/DD HH:mm:ss')
          .format('MM-DD-YYYY')
          .toString()
      : ''
  },
  styles: {
    filterButton: {
      float: 'right',
      marginTop: '4px'
    },
    amountField: Object.assign({}, field, {
      width: '125px'
    })
  }
})
